module.exports = __webpack_public_path__ + "static/media/right_align_03.97c8804a.jpeg";